window.addEventListener('load', () => {
  // window fit image
  document.getElementsByClassName('mainslider-wrap')[0].style.height = Math.round(window.innerHeight/3) + 'px'
  // swiper



  // scroll controler
  let renderSyncSrvc = false
  judgePlicingPla = document.getElementById('fixed-plicing').getBoundingClientRect().top;
  judgePlicing = document.getElementById('fixed-plicing').getBoundingClientRect().top + pageYOffset;
  judgePlicingEnd = document.getElementsByClassName('smart-judge-plicing')[0].getBoundingClientRect().top + pageYOffset
  let scrollEvent = () => {
    if (!renderSyncSrvc) {
        requestAnimationFrame(() => {
        renderSyncSrvc = false

        //scroll parallax
        if (window.innerHeight >= window.pageYOffset) {
          // let calcPosition = window.pageYOffset / 25
          // [15 - 25] : ほぼphotoを固定したような感じ  [ 30 - 50]
          let calcPosition = window.pageYOffset / 32
          let calcPositionHeader = window.pageYOffset / 24
          document.getElementsByClassName('js_parallax')[0].style.top = (50 + calcPosition) + '%'
          document.getElementsByClassName('js_header')[0].style.transform = 'translateY(' + calcPositionHeader + '%)'
        }

      }) //requestAnimationFrame
    } //if rendersyncSrvc
  } //scrollEvent

  document.addEventListener('scroll', scrollEvent, {passive: true})


  // SWITCH PRICING
  let roomsMaterials = document.getElementsByClassName('switch-pricing')[0].children

  for (let $index = 0; $index < roomsMaterials.length; $index++) {
    roomsMaterials[$index].onclick = function (){
      this.classList.toggle('active')
    }

    if (window.matchMedia('(min-width: 992px)').matches) {
      roomsMaterials[$index].addEventListener('mouseover', function(event){
        this.classList.add('active')
      })
      roomsMaterials[$index].addEventListener('mouseleave', function(event){
        this.classList.remove('active')
      })
    }

  }
  // END SWITCH PRICING
}) // onload
